import React from "react";
import { NavLink } from "react-router-dom";

class AboutCompany6 extends React.Component {
  render() {
    return (
      <>
        <div className="section-full p-t80 bg-white">
          <div className="container">
            <div className="section-content ">
              <div className="m-service-containt text-black">
                <div className="row">
                  <div className="col-md-5 col-sm-12">
                    <div className="service-about-left">
                      <div className="mt-media">
                        <img
                          src={require("./../../images/extfile/cranes-are-lifting-materials-at-a-busy-constructio-2024-10-16-23-07-58-utc.jpg")}
                          alt=""
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-7 col-sm-12">
                    <div className="service-about-right m-b30">
                      <h3 className="m-t0">Public Health Engineering(PHE)</h3>
                      <p>
                        At KUO ENTERPRISES LLP, our Public Health Engineering
                        (PHE) services focus on delivering safe, efficient, and
                        sustainable water management solutions that support
                        healthier and environmentally responsible living
                        environments. Our expertise in PHE includes a range of
                        essential utilities for effective water usage,
                        treatment, and conservation, tailored to the needs of
                        residential, commercial, and industrial spaces.
                      </p>
                      <h4>Our Public Health Engineering Services Include:-</h4>
                      <p>
                        <b>Water Systems:</b>
                        Comprehensive solutions for rainwater, cold water,
                        treated wastewater, sewage, raw water, and hot water
                        management. We ensure that all water systems are
                        designed and implemented for optimal functionality and
                        safety.
                      </p>
                      <p>
                        <b>Rainwater Harvesting Utilities:</b>
                        Specialized systems to collect, store, and utilize
                        rainwater, reducing dependency on conventional water
                        sources and promoting sustainable water usage.
                      </p>
                      <p>
                        <b>Solar Water Heating:</b>
                        Energy-efficient solutions that harness solar power to
                        provide hot water, minimizing energy consumption and
                        carbon footprint.
                      </p>
                      <p>
                        <b>Drainage and Pumping Stations:</b>
                        Design and installation of robust drainage systems,
                        including both underground and aboveground
                        infrastructure. Our solutions manage stormwater
                        effectively to prevent flooding and ensure safe water
                        discharge.
                      </p>
                      <p>
                        <b>Environmental Management and Drainage: </b>
                        Comprehensive strategies for environmental management,
                        focusing on sustainable drainage solutions that minimize
                        the environmental impact of water discharge.
                      </p>
                      <p>
                        <b>Environmental Impact Assessment (EIA):</b>
                        Thorough assessments to evaluate the environmental
                        impact of water projects, ensuring compliance with
                        regulatory standards and supporting eco-friendly
                        initiatives.
                      </p>
                      <p>
                        <b>Water Treatment and Audits:</b>
                        Implementation of water treatment systems to provide
                        clean, safe water. Our water audit services identify
                        potential areas for conservation, helping clients
                        optimize water use and reduce wastage.
                      </p>
                      <p>
                        Our PHE services are designed to uphold the highest
                        standards of quality, safety, and environmental
                        stewardship. At KUO ENTERPRISES LLP, we’re committed to
                        creating water management solutions that enhance public
                        health, conserve resources, and contribute to
                        sustainable urban and industrial development.
                      </p>

                      <div className="call-for-quote-outer">
                        <div className="call-quote">
                          <span>Call For a Quote:</span>
                          <h4> +91 8921197287, 9437630763</h4>
                        </div>
                        <div className="call-estimate bg-dark">
                          <NavLink
                            to={"#"}
                            className="site-button-secondry btn-effect"
                          >
                            Online Estimate Form
                          </NavLink>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default AboutCompany6;
